import { Box } from '@chakra-ui/react'
import React from 'react'

const Space = () => {
  return <Box bg="gray.100" p={1} />
}

export default Space
